/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_WorkspaceInputs */

const en_mk_nav_workspace = /** @type {(inputs: Mk_Nav_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product workspace`)
};

const id_mk_nav_workspace = /** @type {(inputs: Mk_Nav_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace produk`)
};

/**
* | output |
* | --- |
* | "Product workspace" |
*
* @param {Mk_Nav_WorkspaceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_workspace = /** @type {((inputs?: Mk_Nav_WorkspaceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_WorkspaceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_workspace(inputs)
	return en_mk_nav_workspace(inputs)
});